import { Component } from '@angular/core';
import { PaymentService } from '@app/data-services/payment.service';
import { PaymentConstants } from '@app/modules/payment/payment-constants';

@Component({
    selector: 'app-payment-stepper',
    templateUrl: './payment-stepper.component.html',
    styleUrls: ['./payment-stepper.component.scss'],
})
export class PaymentStepperComponent {
    steps: any = PaymentConstants.STEPS;
    currentStep = 1;

    public readonly Object = Object;

    commission$ = this.paymentService.commission$;

    constructor(private paymentService: PaymentService) {}

    goNextStep() {
        this.currentStep = this.currentStep + 1;
    }

    goBackStep() {
        this.currentStep = this.currentStep - 1;
    }
}
